/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Waveform_Timeout_MessageInputs */



/**
* | output |
* | --- |
* | "If this takes longer than a minute please use the legacy timeline" |
*
* @param {Timeline_Waveform_Timeout_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_waveform_timeout_message = /** @type {((inputs?: Timeline_Waveform_Timeout_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Waveform_Timeout_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si cela prend plus d'une minute, veuillez utiliser la chronologie heritee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Falls dies länger als eine Minute dauert, verwenden Sie bitte die ältere Zeitleiste.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Se l'operazione richiede più di un minuto, utilizzare la cronologia precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Если это займет больше минуты, пожалуйста, воспользуйтесь старой временной шкалой.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Si esto toma más de un minuto, utilice la línea de tiempo heredada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如果耗时超过一分钟，请使用旧版时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分以上かかる場合は、従来のタイムラインを使用してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यदि इसमें एक मिनट से अधिक समय लगता है तो कृपया पुरानी टाइमलाइन का उपयोग करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Se isso demorar mais de um minuto, use a linha do tempo antiga.")
	return /** @type {LocalizedString} */ ("If this takes longer than a minute please use the legacy timeline")
});